import { INIT_STATUSES, CLEAR_STATUSES } from '../type';
import axiosInstance from '../../config/axios.config';
import { remove, success } from './loader.action';
import { getOnlyOneDeviceFromServer } from './devices.action';
import { getOnlyOneUippsFromServer } from './uipps.action';

export const initStatuses = (statuses, path, selectedStatus, selectedDateSort) => ({
  type: INIT_STATUSES,
  payload: statuses,
  statusType: path,
  selectedStatus: selectedStatus,
  selectedDateSort: selectedDateSort,
});

export const clearStatuses = (statuses, path) => ({
  type: CLEAR_STATUSES,
  payload: [],
});

//получение статусов в зависимости от переданного пути, путь так же передается в редьюсер чтобы  определить какие данные обновить
export const initStatusesFromServer =
  (deviceId, path, selectedStatus, selectedDateSort) => async (dispatch, getState) => {
    const loader = getState().loader;
    try {
      if (!['storage', 'usage', 'repair', 'archive'].includes(path)) {
        throw new Error('Некорректный путь');
      }
      const { data } = await axiosInstance(`/api/devices/${deviceId}/${path}`);
      dispatch(initStatuses(data, path, selectedStatus, selectedDateSort));
      if (!loader?.isLoading && loader?.isSuccess) {
        dispatch(remove());
      }
    } catch (error) {
      console.log(error);
    }
  };

// изменение статуса хранение
export const editStorageStatusFromServer =
  ({ payload, deviceId, statusId, type, path }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.put(`/api/devices/${deviceId}/storage/${statusId}`, payload);
      if (response.status === 200) {
        dispatch(success());
        dispatch(initStatusesFromServer(deviceId, path));
        if (type !== 4) {
          dispatch(getOnlyOneDeviceFromServer(deviceId));
        }
        if (type === 4) {
          dispatch(getOnlyOneUippsFromServer(deviceId));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

// изменение статуса направление в ремонт
export const editRepairStatusFromServer =
  ({ payload, deviceId, typeId, statusId, path }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.put(`/api/devices/${deviceId}/repair/${statusId}`, payload);
      if (response.status === 200) {
        dispatch(success());
        dispatch(initStatusesFromServer(deviceId, path));
        if (typeId !== 4) {
          dispatch(getOnlyOneDeviceFromServer(deviceId));
        }
        if (typeId === 4) {
          dispatch(getOnlyOneUippsFromServer(deviceId));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

// изменение статуса "Выдача" Эксплуатация
export const editOperationStatusFromServer = ({statusId, deviceId, payload, typeId, path}) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`/api/devices/${deviceId}/usage/${statusId}`, payload);
    if (response.status === 200) {
      dispatch(success());
      await dispatch(initStatusesFromServer(deviceId, path));
      if (Number(typeId) === 4) {
        dispatch(getOnlyOneUippsFromServer(deviceId));
      } else {
        dispatch(getOnlyOneDeviceFromServer(deviceId));
      }
    }
  } catch (error) {
    console.log(error);
  }
};
